// This composable allows for attaching GIFs to modals that might have progress stored already. It accepts a list of save keys
// that it commits to modal data and stores in the process of having the GIF modal open, then reinstantiates when the primary
// modal is reopened post-GIF-modal.
// NOTE: Modal flows that are rooted in Vuex state probably don't need this, they can just store values in modules.
// This is for simpler modal flows that aren't using state outside of `state.modal`.
import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';

const useGifAttaching = ({ progressKeys }) => {
  const { state, commit } = useStore();

  const loadProgress = () => {
    for (const [key, refOrComputed] of Object.entries(progressKeys())) {
      // This will give a warning if computed prop, since you can't overwrite.
      // That's fine, just ignore it.
      if (state.modal.data[key]) refOrComputed.value = state.modal.data[key];
    }
  };
  const saveProgress = () => {
    const newData = {};
    for (const [key, refOrComputed] of Object.entries(progressKeys())) {
      newData[key] = refOrComputed.value;
    }
    commit('updateModalData', newData);
  };
  const saveProgressAndMoveToGifModal = () => {
    // Save Progress to Modal Data
    saveProgress();
    // Open Gif Modal
    commit('updateModal', {
      visible: true,
      subcomponent: 'onboarding-events-modals-gif-search',
      data: {
        attachGif: (url) => { commit('updateModalData', { gifUrl: url }); },
        originalModal: state.modal,
      },
      size: 'xxl',
      cancelMutation: 'updateModal',
      cancelArgs: state.modal,
    });
  };

  // Lifecycle Hooks
  onBeforeMount(() => {
    // If this is being opened post GIF flow, we want to instantiate every value with what had previously been saved in modal data.
    loadProgress();
  });

  return { loadProgress, saveProgress, saveProgressAndMoveToGifModal };
};

export default useGifAttaching;
